import styled from "styled-components";

export const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.backgroundSecondary};
`;

export const TextWrapper = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  text-align: left;
  a {
    color: ${(props) => props.theme.colors.textLinkPrimary};
  }
  padding: ${(props) => props.theme.spacing(4, 2)};
  @media ${({ theme: { media } }) => media.tablet} {
    padding: ${(props) => props.theme.spacing(8, 4)};
  )}
  @media ${({ theme: { media } }) => media.desktop} {
    padding: ${(props) => props.theme.spacing(8, 8)};
  )}
`;

// the anchor styling is copied from core components --
// unable to use actual core components due to the tags being inside a content id
export const PolicyWrapper = styled.div`
  padding: ${(props) => props.theme.spacing(2, 0)};
  background-color: ${(props) => props.theme.colors.backgroundPrimary};
  a {
    color: rgb(0, 117, 196);
    fill: rgb(0, 117, 196);
    &:hover {
      background-color: transparent;
      color: rgb(0, 107, 180);
      fill: rgb(0, 107, 180);
      border: none;
    }
  }
`;

export const PolicyTitle = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title3)};
  margin: ${(props) => props.theme.spacing(8, 0)};
  color: ${(props) => props.theme.colors.textDarker};
`;

export const SectionDiv = styled.div`
  margin: ${(props) => props.theme.spacing(4, 0)};
  padding: ${(props) => props.theme.spacing(0, 4)};
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin: ${(props) => props.theme.spacing(8, 0)};
    padding: ${(props) => props.theme.spacing(0, 8)};
  )}
`;

export const SectionTitle = styled.div`
  padding: ${(props) => props.theme.spacing(2, 0)};
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title4)};
`;

export const SectionContent = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
  color: ${(props) => props.theme.colors.textPrimary};

  /* Tables are wrapped in .table-scroll (see App.tsx). The wrapper is the
     horizontal scroll container, so only the table scrolls — the surrounding
     paragraphs stay put. It bleeds past TextWrapper + SectionDiv's combined
     horizontal padding so the table can use the full screen width; the left
     padding is kept as a resting gutter that lines the table up with the body
     text. Keeping the scroll on this wrapper (not the <table>) avoids the
     WebKit bug where a display:block table under-reports its scroll width and
     clips the last column. */
  .table-scroll {
    overflow-x: auto;
    margin: 0 -${(props) => props.theme.spacing(6)};
    padding-left: ${(props) => props.theme.spacing(6)};
    padding-right: ${(props) => props.theme.spacing(6)};
    @media ${({ theme: { media } }) => media.tablet} {
      margin: 0 -${(props) => props.theme.spacing(12)};
      padding-left: ${(props) => props.theme.spacing(12)};
      padding-right: ${(props) => props.theme.spacing(12)};
    }
    @media ${({ theme: { media } }) => media.desktop} {
      margin: 0 -${(props) => props.theme.spacing(16)};
      padding-left: ${(props) => props.theme.spacing(16)};
      padding-right: ${(props) => props.theme.spacing(16)};
    }
  }

  table {
    width: 100%;
    /* Floor the table width (not the cells) so columns stay readable: min-width
       on the table is honored strictly and wins over width:100% on small
       screens, so the table overflows the .table-scroll wrapper and scrolls
       instead of squeezing columns to fit. width:100% still lets it fill wider
       containers on desktop. (Cell min-width is treated as a soft hint once
       width:100% caps the table, which is why the columns collapsed.) */
    min-width: ${(props) => props.theme.spacing(180)};
    table-layout: auto;

    td,
    th {
      border: 1px solid ${(props) => props.theme.colors.borderPrimary};
      padding: ${(props) => props.theme.spacing(0, 2)};
    }
  }

  li {
    margin-left: ${(props) => props.theme.spacing(5)};
  }
`;
